module.exports = __webpack_public_path__ + "static/react-nails-logo-c48b4b5f705dd9a389a26cf92fc6b289.png";